import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center gap-2" }
const _hoisted_2 = { style: {"font-family":"var(--an-font)","font-weight":"600","font-size":"13px"} }

import { computed } from 'vue';
import { useToast } from '@/composables/useToast';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseToast',
  setup(__props) {

const { toastState } = useToast();

const icon = computed(() => {
  switch (toastState.type) {
    case 'success': return 'fas fa-check-circle';
    case 'error':   return 'fas fa-exclamation-circle';
    case 'warning': return 'fas fa-exclamation-triangle';
    default:        return 'fas fa-info-circle';
  }
});

const snackColor = computed(() => {
  switch (toastState.type) {
    case 'success': return '#2E7D5A';
    case 'error':   return '#E53935';
    case 'warning': return '#F5A623';
    default:        return '#374151';
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_snackbar, {
    modelValue: _unref(toastState).isVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(toastState).isVisible) = $event)),
    color: snackColor.value,
    timeout: _unref(toastState).duration,
    location: "top",
    rounded: "lg",
    elevation: "4"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (icon.value)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass(icon.value),
              style: {"font-size":"16px"}
            }, null, 2))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(toastState).message), 1)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "color", "timeout"]))
}
}

})